// Productdetails: op groot scherm staan de uitklapblokken altijd open (zoals het prototype), op mobiel klapbaar.
const wide = matchMedia('(min-width: 900px)');
const sync = () => {
  document.querySelectorAll('.pd__acc').forEach((d) => {
    if (wide.matches) d.open = true;
  });
};
sync();
wide.addEventListener('change', sync);
